import moment from "moment";
import "moment/locale/es"; // este justo después de moment
import React, { useEffect, useMemo, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
//import "../styles/Resultados.css";
import Swal from "sweetalert2";
import AgendaContenedor from "../Components/Citas/AgendaContenedor";
import PacienteCreacion from "../Components/Configuracion/ModalCreacion/PacienteCreacion";
import ModalCita from "../Components/Citas/ModalCita";
import { normalizarResumenDia } from "../utils/resumenCitas";
import RailEspecialidades from "../Components/Citas/RailEspecialidades";
import BarraFecha from "../Components/Citas/BarraFecha";
import "../styles/CitasRail.css";
import {
  createCitaPaciente,
  ListarFacturasPendientesPaciente,
  ContarCitasPorEspecialidad,
  ActualizarEstadoCita,
} from "../Service/Service.citas";
import { CITA_FINALIZADA_SENTINEL } from "../utils/citaFinalizadaAlert";
import {
  GetProcedimientosDisponiblesCita,
  ControllerListarProcedimientosDeCita,
} from "../Service/Service.porcedimientos";

import { ControllerListarCitasDoctor } from "../Service/Service.doctor";
import {
  ListarDoctoresEspecialidadClinica,
  ListarEspecialidadClinicaActivas,
} from "../Service/Service.especialidad";
import { ListarPacientes } from "../Service/Service.paciente";
import { ListarEstadoCitas, ListarTipoCitas } from "../Service/Service.util";
import { GetTokenDecoded } from "../utils/storeUsuario";
import usePermissions from "../hook/usePermissions";

moment.locale("es");

export default function GestionCitas() {
  // RBAC-CUTOVER-02: crear paciente desde esta pantalla exige pacientes.create
  // (mismo permiso que en Pacientes.js -- cierra el bypass visual alternativo
  // detectado en RBAC-VERIFY-01); Guardar cita exige citas.create o
  // citas.edit segun `citapaciente.idcita` (misma dualidad que el backend,
  // ver RequireCitaCreateOrEditPermission).
  const { hasPermission } = usePermissions();
  const [show, setShow] = useState(false);
  const [showPaciente, setShowPaciente] = useState(false);
  const [idclinica, setIdClinica] = useState(GetTokenDecoded().idclinica);
  const [selectedOption, setSelectedOption] = useState(null);
  const [ping, setPing] = useState(false);
  const [estadosCitas, setEstadosCitas] = useState([]);
  const [tipoCitas, setTipoCitas] = useState([]);
  const [especialidadesActivas, setEspecialidadesActivas] = useState([]);
  // CITAS-UI FASE 1: sólo para marcar la fila activa del rail. No cambia
  // ninguna decisión: la especialidad sigue viajando en la URL como hasta
  // ahora, y de ahí la lee el resto de la pantalla.
  const [idEspecialidadActiva, setIdEspecialidadActiva] = useState(
    () => new URLSearchParams(window.location.search).get("idespecialidad")
  );

  // La especialidad activa como OBJETO, para que el chip pueda mostrar su
  // nombre. Se deriva de la lista que ya está en memoria: sin llamadas nuevas.
  const especialidadSeleccionada =
    especialidadesActivas.find(
      (e) => Number(e?.idespecialidad) === Number(idEspecialidadActiva)
    ) ?? null;
  const [doctoresEspecialidades, setDoctoresEspecialidades] = useState([]);
  const [citasDoctotes, setCitasDoctotes] = useState([]);
  const [iddoct, setIdDoctor] = useState([]);
  const [paciente, setPaciente] = useState([]);
  //const [fecha, setFecha] = useState(moment().format('YYYY-MM-DD'));
  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  // Filtro por estado de la agenda. `null` = todos (que no es lo mismo que una
  // lista vacía: eso sería haber desmarcado los siete a mano). Vive aquí y no
  // en la barra porque la cuadrícula también lo necesita.
  const [estadosVisibles, setEstadosVisibles] = useState(null);
  /* CITAS-RESUMEN: el filtro de COBERTURA. El de estado ya existía
     (`estadosVisibles`) y se reutiliza sin tocarlo; éste es lo único nuevo.
     Atenúa, no oculta: un cupo ocupado que desapareciera se vería libre. */
  const [filtroCobertura, setFiltroCobertura] = useState(null);

  /* Al cambiar de día o de especialidad, el filtro de cobertura deja de tener
     sentido: son otras citas. Se limpia SÓLO el nuevo -- `estadosVisibles` se
     deja como estaba, porque tocarlo cambiaría el comportamiento que ya tenía
     el botón Filtros. */
  useEffect(() => {
    setFiltroCobertura(null);
  }, [fecha, idEspecialidadActiva]);
  // CITAS-CONTEO-ESPECIALIDAD: { idespecialidad: total } del día mostrado.
  const [conteosEspecialidad, setConteosEspecialidad] = useState({});
  /* CITAS-RESUMEN-DIA: el resumen de TODO lo agendado ese día, tal cual lo
     devuelve /citas/conteo-especialidad. `undefined` = aún cargando;
     `null` = el backend no lo mandó o falló (la etiqueta no se muestra). */
  const [resumenDia, setResumenDia] = useState(undefined);
  const [doctor, setDoctor] = useState({});
  const [hora, setHora] = useState({});

  const [facturasPendientes, setFacturasPendientes] = useState([]);
  const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([]);

  // CITAS-PROCEDIMIENTOS-02/03: procedimientos/tarifario validos para el
  // paciente seleccionado (mismo catalogo/filtro por seguro que ya usa
  // Facturacion en ProcedimientosNuevosFactura.js), los que el usuario dejo
  // seleccionados (nuevos + existentes que se mantienen), y los ya
  // facturados de la cita (solo lectura, nunca editables desde aqui).
  const [procedimientosOpciones, setProcedimientosOpciones] = useState([]);
  const [procedimientosSeleccionados, setProcedimientosSeleccionados] = useState([]);
  const [procedimientosFacturados, setProcedimientosFacturados] = useState([]);
  const [cargandoProcedimientos, setCargandoProcedimientos] = useState(false);
  // CITAS-SEGURO-PLAN-PROCEDIMIENTOS-07: aviso cuando el asegurado no tiene un
  // plan activo con prestaciones (no se muestra el catalogo general como fallback).
  const [avisoProcedimientos, setAvisoProcedimientos] = useState("");
  const [guardando, setGuardando] = useState(false);

  const initialCita = {
    motivo: "",
    idtipo_cita: 0,
    fecha_inicio: "",
    hora_inicio: "",
    hora_fin: "",
    idpaciente: 0,
    nombre: "",
    iddoctor: 0,
    id_estado_cita: 0,
    idcita: 0,
    idclinica: idclinica,
    celular: "",
  };
  const [citapaciente, setCitaPaciente] = useState(initialCita);

  /* El intervalo de la especialidad, que es la duración por defecto de una
     cita nueva. Sale del MISMO sitio que las franjas de la cuadrícula
     (`clinica_especialidades.intervalo_tiempo`): no es un valor fijo -- en
     datos reales va de 10 a 120 minutos -- ni una llamada nueva. */
  const intervaloEspecialidad =
    especialidadSeleccionada?.intervalo_tiempo ??
    doctoresEspecialidades[0]?.especialidades?.clinica_especialidades?.[0]
      ?.intervalo_tiempo;

  /* El resumen del día ya viene contado del backend -- particular vs
     cubierto, estados, aseguradoras, ocupación -- porque el front sólo tiene
     en memoria una especialidad. Aquí sólo se le da forma. */
  const resumen = useMemo(() => normalizarResumenDia(resumenDia), [resumenDia]);

  const etiquetaAlcance = useMemo(
    () => `Todo lo agendado · ${moment(fecha).format("dddd D [de] MMMM")}`,
    [fecha]
  );

  /* Cancelar la cita sólo se ofrece cuando el backend lo va a aceptar:
     `guardCitaNoReapertura` rechaza una Finalizada (6), y Cancelada (7) o
     Eliminada (8) ya están donde estarían. Mejor no mostrar el enlace que
     mostrarlo para que devuelva un 409. */
  const puedeCancelarEstaCita =
    hasPermission("citas.status_change") &&
    ![6, 7, 8].includes(Number(citapaciente.id_estado_cita));

  const fechasConCitas = ["2025-06-17", "2025-06-19", "2025-06-24"];

  const handleClose = () => {
    setShow(false);
    setCitaPaciente(initialCita);
    setSelectedOption(null);
    setDoctor({});
    setProcedimientosOpciones([]);
    setProcedimientosSeleccionados([]);
    setProcedimientosFacturados([]);
  };

  const handleShow = () => {
    setCitaPaciente(initialCita);
    setSelectedOption(null);
    setDoctor({});
    setHora({});
    setProcedimientosOpciones([]);
    setProcedimientosSeleccionados([]);
    setProcedimientosFacturados([]);
    setShow(true);
  };

  const handleClosePaciente = async () => {
    setShowPaciente(false);
    const pacint = await ListarPacientes(idclinica);
    if (pacint.success) {
      setPaciente(
        pacint.data.map((p) => ({
          value: p.idpaciente,
          label: p.nombres_completos,
          ...p,
        }))
      );
    }
  };

  const handleShowPaciente = () => setShowPaciente(true);

  /* ------------------------------------------------------------------
     CITAS-MODAL: los tres manejadores que el modal rediseñado necesita.
     Viven aquí, con el resto del estado; el modal sólo los invoca.
     ------------------------------------------------------------------ */

  /**
   * Cerrar con algo sin guardar pregunta antes. `hayCambios` lo calcula el
   * modal comparando contra la foto que tomó al abrirse; la confirmación se
   * queda aquí, donde ya estaba Swal.
   */
  const cerrarModalCita = async (hayCambios) => {
    if (!hayCambios) {
      handleClose();
      return;
    }
    const { isConfirmed } = await Swal.fire({
      title: "¿Descartar los cambios?",
      text: "Lo que escribiste en esta cita se perderá.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Descartar",
      cancelButtonText: "Seguir editando",
    });
    if (isConfirmed) handleClose();
  };

  /**
   * Cambiar el paciente de una cita YA creada. El sistema lo permite y no hay
   * ninguna regla que lo impida -- ni en el backend ni en la base -- así que
   * no se prohíbe: sólo se deja de poder hacer por descuido.
   */
  const cambiarPacienteDeCita = async () => {
    const { isConfirmed } = await Swal.fire({
      title: "¿Cambiar el paciente de esta cita?",
      text: "Los procedimientos elegidos se recalcularán según la cobertura del nuevo paciente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiarlo",
      cancelButtonText: "No",
    });
    if (!isConfirmed) return;
    setSelectedOption(null);
    setCitaPaciente((prev) => ({ ...prev, idpaciente: 0 }));
    setProcedimientosSeleccionados([]);
    setFacturasPendientes([]);
    setFacturasSeleccionadas([]);
  };

  /**
   * Cancelar la cita = estado 7 vía `POST /up_estado_cita`, el mismo endpoint
   * y el mismo permiso (`citas.status_change`) que ya usa la consulta. NO se
   * borra nada: borrar es otro endpoint y otro permiso.
   */
  const cancelarCita = async () => {
    const { isConfirmed } = await Swal.fire({
      title: `¿Cancelar la cita #${citapaciente.idcita}?`,
      text: "El cupo queda libre y la cita se marca como Cancelada. No se borra.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cancelarla",
      cancelButtonText: "No",
    });
    if (!isConfirmed) return;

    setGuardando(true);
    const resp = await ActualizarEstadoCita({
      idcita: citapaciente.idcita,
      estado: 7,
    });
    setGuardando(false);

    if (resp?.success) {
      Swal.fire("Cita cancelada", "", "success");
      handleClose();
      setPing(!ping);
      return;
    }
    // El backend puede negarse por sus guardas (una cita Finalizada no se
    // reabre). Se muestra SU mensaje, no uno inventado aquí.
    Swal.fire("No se pudo cancelar", resp?.message || "Inténtalo de nuevo.", "error");
  };

  const ListarDoctoresEspecialidad = async (
    idespecialidad,
    idclinica,
    fecha
  ) => {
    const response = await ListarDoctoresEspecialidadClinica(
      idespecialidad,
      idclinica
    );
    window.history.pushState(
      {},
      null,
      `?idespecialidad=${idespecialidad}&idclinica=${idclinica}`
    );
    // CITAS-UI FASE 1: misma URL de siempre; esto sólo pinta la fila activa.
    setIdEspecialidadActiva(idespecialidad);
    if (response.success) {
      const iddoct = response.data.map((d) => d.iddoctor);
      setIdDoctor(iddoct);
      const citasActuales = await ControllerListarCitasDoctor(
        iddoct,
        fecha,
        idespecialidad
      );
      if (citasActuales.success) {
        setCitasDoctotes(citasActuales.data);
        setDoctoresEspecialidades(response.data);
      }
    } else {
      setDoctoresEspecialidades([]);
    }
  };

  const GuardarCitaAnterior = async () => {
    const idespecialidad = new URLSearchParams(window.location.search).get(
      "idespecialidad"
    );
    const idclinica = new URLSearchParams(window.location.search).get(
      "idclinica"
    );

    if (!citapaciente.idpaciente) {
      Swal.fire({ icon: "warning", title: "Seleccione un paciente" });
      return;
    }

    const citaConEspecialidad = {
      ...citapaciente,
      idespecialidad: parseInt(idespecialidad),
      idclinica: parseInt(idclinica),
    };

    const response = await createCitaPaciente(citaConEspecialidad);
    if (response.success) {
      Swal.fire({
        icon: "success",
        title: response.message,
        timer: 1500,
        showConfirmButton: false,
      });
      await ListarDoctoresEspecialidad(idespecialidad, idclinica, fecha);
      setPing(!ping);
      handleClose();
    } else {
      Swal.fire({
        icon: "error",
        title: "Error al crear la cita",
        text: response.message,
      });
    }
  };
  const GuardarCita = async () => {
    // CITAS-PROCEDIMIENTOS-02 seccion J: bloquea doble-click/doble-submit
    // mientras la operacion esta en curso.
    if (guardando) return;

    const idespecialidad = new URLSearchParams(window.location.search).get(
      "idespecialidad"
    );
    const idclinica = new URLSearchParams(window.location.search).get(
      "idclinica"
    );

    if (!citapaciente.idpaciente) {
      Swal.fire({ icon: "warning", title: "Seleccione un paciente" });
      return;
    }

    // Validar que tenga hora de inicio y fin
    if (!citapaciente.hora_inicio || !citapaciente.hora_fin) {
      Swal.fire({
        icon: "warning",
        title: "Debe ingresar la hora de inicio y fin",
      });
      return;
    }

    // Validar selección de tipo cita
    if (!citapaciente.idtipo_cita) {
      Swal.fire({ icon: "warning", title: "Debe seleccionar el tipo de cita" });
      return;
    }

    // CITAS-PROCEDIMIENTOS-03 seccion I: no se permite guardar (crear ni
    // editar) sin al menos un procedimiento seleccionado. Doble proteccion:
    // esto es la guard clause; el boton Guardar tambien queda deshabilitado
    // (ver disabled del boton mas abajo) -- no se depende solo de `disabled`.
    if (procedimientosSeleccionados.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Debe seleccionar al menos un procedimiento.",
      });
      return;
    }

    // 🔹 Construimos el objeto final a enviar al backend
    const citaConEspecialidad = {
      ...citapaciente,
      idespecialidad: parseInt(idespecialidad),
      idclinica: parseInt(idclinica),
      facturas: facturasSeleccionadas?.map((f) => f.value) || [], // 👈 aquí enviamos los idfactura seleccionados
      // CITAS-PROCEDIMIENTOS-01/03: contrato real de backend (POST
      // /create_cita, campo `procedimientos`). NUNCA se envia `precio` -- el
      // backend es la unica fuente de verdad (procedimiento_company_precios.precio).
      // - Nuevo (sin idprocedimiento_cita_paciente): {examen_tipo_id, seguro_id}
      // - Existente que se mantiene (edicion): {idprocedimiento_cita_paciente}
      //   -- el backend jamas recalcula su precio historico.
      // Un procedimiento ya facturado nunca aparece en `procedimientosSeleccionados`
      // (vive aparte en `procedimientosFacturados`, solo lectura), por lo que
      // nunca se envia y el backend nunca lo toca.
      procedimientos: procedimientosSeleccionados.map((p) =>
        p.idprocedimiento_cita_paciente
          ? { idprocedimiento_cita_paciente: p.idprocedimiento_cita_paciente }
          : { examen_tipo_id: p.value, ...(p.seguro_id ? { seguro_id: p.seguro_id } : {}) }
      ),
    };

    setGuardando(true);
    try {
      const response = await createCitaPaciente(citaConEspecialidad);

      // LOCK-CITA-FINALIZADA-26: createCitaPaciente ya mostro el aviso
      // especifico de "cita finalizada" (toast, ver citaFinalizadaAlert.js) --
      // no mostrar ademas el Swal de error generico de abajo para el mismo
      // fallo (mismo patron ya usado en ModalLaboratorio.js).
      if (response === CITA_FINALIZADA_SENTINEL) {
        return;
      }

      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: response.message,
          timer: 1500,
          showConfirmButton: false,
        });

        // Recargamos las citas del doctor para actualizar el calendario
        await ListarDoctoresEspecialidad(idespecialidad, idclinica, fecha);

        setPing(!ping);
        handleClose();
      } else {
        // CITAS-PROCEDIMIENTOS-02 seccion I: response.message viene del backend
        // (incluye los 422/403/404 de CITAS-PROCEDIMIENTOS-01 -- seguro
        // incompatible, tarifario inexistente, procedimiento invalido,
        // duplicado, scope) gracias al fix en Service.citas.js. Se muestra tal
        // cual quedo el mensaje del backend en vez de degradarlo a uno generico.
        Swal.fire({
          icon: "error",
          title: "Error al crear la cita",
          text: response?.message || "No se pudo guardar la cita.",
        });
      }
    } catch (error) {
      console.error("Error al guardar la cita:", error);
      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No se pudo guardar la cita. Intente nuevamente.",
      });
    } finally {
      setGuardando(false);
    }
  };

  // CITAS-CONTEO-ESPECIALIDAD: se recarga al cambiar de día, que es cuando el
  // numero deja de ser valido. UNA peticion agregada, no una por especialidad.
  useEffect(() => {
    let vigente = true;
    setResumenDia(undefined);
    (async () => {
      const r = await ContarCitasPorEspecialidad(fecha);
      if (!vigente) return;
      // Si falla, se deja vacio: el rail se pinta sin numeros, la etiqueta de
      // resumen no se muestra y la agenda sigue funcionando igual.
      const mapa = {};
      if (r?.success) {
        (r.data || []).forEach((x) => {
          mapa[x.idespecialidad] = x.total;
        });
      }
      setConteosEspecialidad(mapa);
      setResumenDia(r?.success ? r.resumenDia ?? null : null);
    })();
    return () => {
      vigente = false;
    };
  }, [fecha]);

  useEffect(() => {
    (async () => {
      setIdClinica(GetTokenDecoded().idclinica);
      const espActiv = await ListarEspecialidadClinicaActivas(
        GetTokenDecoded().idclinica
      );
      if (espActiv.success) setEspecialidadesActivas(espActiv.data);
      const pacint = await ListarPacientes(GetTokenDecoded().idclinica);
      if (pacint.success)
        setPaciente(
          pacint.data.map((p) => ({
            value: p.idpaciente,
            label: p.nombres_completos,
            ...p,
          }))
        );
      const estd = await ListarEstadoCitas();
      if (estd.success) setEstadosCitas(estd.data);
      const tip = await ListarTipoCitas();
      if (tip.success) setTipoCitas(tip.data);
    })();
  }, [ping]);

  useEffect(() => {
    const fetchCitas = async () => {
      const idespecialidad = parseInt(
        new URLSearchParams(window.location.search).get("idespecialidad")
      );
      const idclinica = parseInt(
        new URLSearchParams(window.location.search).get("idclinica")
      );
      if (iddoct.length > 0 && idespecialidad && idclinica) {
        const citasActuales = await ControllerListarCitasDoctor(
          iddoct,
          fecha,
          idespecialidad
        );
        if (citasActuales.success) setCitasDoctotes(citasActuales.data);
      }
    };
    fetchCitas();
  }, [fecha, iddoct]);

  // CITAS-PROCEDIMIENTOS-02/03: carga el tarifario valido para el paciente
  // seleccionado -- mismo endpoint/misma logica de filtrado por seguro que ya
  // usa Facturacion en ProcedimientosNuevosFactura.js (GET /procedimiento_precios,
  // scope de company resuelto server-side por JWT; el filtro por seguro_id del
  // paciente se aplica aqui, en frontend, igual que alli).
  //
  // En EDICION (citapaciente.idcita presente) ademas carga los procedimientos
  // YA vinculados a esa cita (GET /cita_procedimiento?idcita=, reutilizado y
  // corregido en CITAS-PROCEDIMIENTOS-03 -- antes sin scoping real) y los
  // separa en:
  //   - manejables (estado IN ["Previsto","Por Cobrar"] && factura_id=null):
  //     se precargan como seleccionados, el usuario puede retirarlos.
  //     FACTURACION-DETONANTE-24: "Previsto" se incluye -- es el estado con
  //     el que nace TODO procedimiento de agenda desde este ticket (mismo
  //     universo "manejable" que el backend, SincronizarProcedimientosParaCita).
  //   - facturados: se muestran aparte, solo lectura, NUNCA se ofrecen para
  //     retirar (ticket seccion F) -- nunca viajan en `procedimientos`.
  // Un procedimiento historico cuyo ExamenTipo ya no tenga tarifario activo
  // hoy igual se muestra (viene de la relacion de la propia fila, no del
  // catalogo de precios activo) -- no se oculta silenciosamente (ticket H).
  //
  // Al cambiar de paciente se limpia la seleccion previa: un procedimiento
  // valido para el tarifario del paciente anterior no necesariamente lo es
  // para el nuevo (seguro distinto).
  useEffect(() => {
    let cancelado = false;

    const cargarProcedimientos = async () => {
      if (!citapaciente.idpaciente) {
        setProcedimientosOpciones([]);
        setProcedimientosSeleccionados([]);
        setProcedimientosFacturados([]);
        setAvisoProcedimientos("");
        return;
      }

      setCargandoProcedimientos(true);
      setAvisoProcedimientos("");

      // CITAS-SEGURO-PLAN-PROCEDIMIENTOS-07: el catalogo lo resuelve el backend
      // segun el plan efectivo del paciente (pacientes.plan_id) -- antes se
      // traia TODO el tarifario y se filtraba por seguro en el cliente, lo que
      // ofrecia prestaciones fuera del plan.
      const [catalogoResult, existentesResult] = await Promise.all([
        GetProcedimientosDisponiblesCita(citapaciente.idpaciente),
        citapaciente.idcita
          ? ControllerListarProcedimientosDeCita(citapaciente.idcita)
          : Promise.resolve({ success: true, data: [] }),
      ]);
      if (cancelado) return;

      if (catalogoResult?.sin_plan) {
        setAvisoProcedimientos(
          catalogoResult.message ||
            "El paciente no tiene un plan activo con prestaciones disponibles."
        );
      }

      const existentes = existentesResult?.success ? existentesResult.data || [] : [];
      const esManejable = (p) =>
        (p.estado === "Previsto" || p.estado === "Por Cobrar") && p.factura_id === null;
      const manejables = existentes.filter(esManejable);
      const facturados = existentes.filter((p) => !esManejable(p));
      const idsExamenManejables = new Set(manejables.map((p) => p.idExamenTipo));

      const labelProcedimiento = (examenTipo, precio) => ({
        label: examenTipo?.codigo
          ? `${examenTipo.codigo} - ${examenTipo?.descripcion || ""}`
          : examenTipo?.descripcion || "Procedimiento",
        // SelectSearchble ya sabe renderizar scope_label como segunda linea --
        // es solo informativo, el precio real lo resuelve/valida el backend.
        scope_label: `$${Number(precio).toFixed(2)}`,
        // CITAS-MODAL: el mismo precio como NUMERO, para poder sumarlo sin
        // deshacer la cadena de arriba. Campo aditivo: no viaja al backend
        // (`GuardarCita` arma objetos explícitos con `examen_tipo_id` o
        // `idprocedimiento_cita_paciente`) y nadie más lo lee.
        precio: Number(precio) || 0,
      });

      if (catalogoResult?.success) {
        const catalogo = (catalogoResult.data || [])
          // El backend ya devolvio SOLO prestaciones validas para el paciente
          // (plan efectivo si es asegurado, tarifario particular si no).
          // Evita ofrecer de nuevo un examen que ya esta manejable en la cita.
          .filter((item) => !idsExamenManejables.has(item.ExamenTipo?.IdExamenTipo))
          .map((item) => ({
            value: item.ExamenTipo?.IdExamenTipo,
            ...labelProcedimiento(item.ExamenTipo, item.precio),
            seguro_id: item.seguro_id,
          }));
        setProcedimientosOpciones(catalogo);
      } else {
        setProcedimientosOpciones([]);
        if (!catalogoResult?.sin_plan && catalogoResult?.message) {
          setAvisoProcedimientos(catalogoResult.message);
        }
      }

      setProcedimientosSeleccionados(
        manejables.map((p) => ({
          value: `existente-${p.idprocedimiento_cita_paciente}`,
          idprocedimiento_cita_paciente: p.idprocedimiento_cita_paciente,
          ...labelProcedimiento(p.ExamenTipo, p.precio),
          seguro_id: p.seguro_id,
        }))
      );
      setProcedimientosFacturados(
        facturados.map((p) => ({
          idprocedimiento_cita_paciente: p.idprocedimiento_cita_paciente,
          label: p.ExamenTipo?.codigo
            ? `${p.ExamenTipo.codigo} - ${p.ExamenTipo?.descripcion || ""}`
            : p.ExamenTipo?.descripcion || "Procedimiento",
          precio: p.precio,
        }))
      );

      setCargandoProcedimientos(false);
    };

    cargarProcedimientos();
    return () => {
      cancelado = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citapaciente.idpaciente, citapaciente.idcita, selectedOption]);

  const handleChangeAntigua = (selectedOption) => {
    setSelectedOption(selectedOption);
    setCitaPaciente((prev) => ({ ...prev, idpaciente: selectedOption.value }));
  };

  const handleChange = async (selectedOption) => {
    // CITAS-PROCEDIMIENTOS-02/03: al editar, DoctorScheduleTable dispara este
    // mismo handler con un objeto minimo ({label, value}, sin `seguros` --
    // ver DoctorScheduleTable.js handleCellClick). Se completa aqui con el
    // objeto completo ya cargado en `paciente` (incluye `seguros`, viene de
    // listar_paciente) para que la resolucion de tarifario funcione igual en
    // creacion y en edicion, sin tocar DoctorScheduleTable.js.
    const pacienteCompleto =
      paciente.find((p) => p.value === selectedOption.value) || selectedOption;
    setSelectedOption(pacienteCompleto);
    setCitaPaciente((prev) => ({ ...prev, idpaciente: selectedOption.value }));
    //alert("Seleccionaste al paciente: " + selectedOption.label);
    // 🔹 Cargar automáticamente las facturas pendientes del paciente
    const resp = await ListarFacturasPendientesPaciente(selectedOption.value);
    //console.log("Facturas pendientes del paciente:", JSON.stringify(resp));
    if (resp?.success) {
      setFacturasPendientes(
        resp.data.map((f) => ({
          value: f.idfactura,
          label: `#${f.num_documento || f.idfactura} - ${moment(
            f.fecha_emision
          ).format("DD/MM/YYYY")} - $${f.total}`,
        }))
      );
    } else {
      setFacturasPendientes([]);
    }
  };

  // CITAS-UI FASE 2: quitar el chip = dejar de filtrar por especialidad. Se
  // limpia la URL y se vacía la agenda, que es exactamente el estado en el que
  // arranca la pantalla cuando se entra sin especialidad. No borra nada ni
  // cambia ninguna cita.
  const quitarEspecialidad = () => {
    window.history.pushState({}, null, window.location.pathname);
    setIdEspecialidadActiva(null);
    setIdDoctor([]);
    setDoctoresEspecialidades([]);
    setCitasDoctotes([]);
  };

  return (
    <>
      <div className="page-content">
        {/* CITAS-UI FASE 1: la especialidad pasa de ocupar la pantalla entera
            (23 tarjetas de 140x80) a un rail de 240px con buscador. La agenda
            sube a la primera pantalla. El calendario grande sigue aquí de
            momento: lo sustituye la barra de fecha de la FASE 2. */}
        <div className="citas-layout">
          <div className="citas-layout__rail">
            <RailEspecialidades
              conteos={conteosEspecialidad}
              especialidades={especialidadesActivas}
              idSeleccionada={idEspecialidadActiva}
              onSeleccionar={(especialidad) =>
                ListarDoctoresEspecialidad(
                  especialidad.idespecialidad,
                  especialidad.idclinica,
                  fecha
                )
              }
            />
          </div>

          <div className="citas-layout__principal">
            {/* CITAS-UI FASE 2: el calendario de 260px, que ocupaba una columna
                fija para algo que se usa una vez, pasa al popover de esta barra.
                La agenda gana esa columna entera. */}
            <BarraFecha
              fecha={fecha}
              onCambiarFecha={setFecha}
              especialidadActiva={especialidadSeleccionada}
              onQuitarEspecialidad={quitarEspecialidad}
              estadosVisibles={estadosVisibles}
              onCambiarEstados={setEstadosVisibles}
              resumen={resumen}
              cuposDia={resumenDia?.cupos ?? null}
              cargandoResumen={resumenDia === undefined}
              etiquetaAlcance={etiquetaAlcance}
              filtroCobertura={filtroCobertura}
              onFiltrarCobertura={setFiltroCobertura}
            />

        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <AgendaContenedor
                  doctoresEspecialidades={doctoresEspecialidades}
                  fecha={fecha}
                  setShow={setShow}
                  setDoctor={setDoctor}
                  setHora={setHora}
                  setCitaPaciente={setCitaPaciente}
                  citasDoctotes={citasDoctotes}
                  handleChange={handleChange}
                  haySeleccion={Boolean(idEspecialidadActiva)}
                  estadosVisibles={estadosVisibles}
                  filtroCobertura={filtroCobertura}
                  onIrDiaSiguiente={() =>
                    setFecha(moment(fecha).add(1, "days").format("YYYY-MM-DD"))
                  }
                />
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
      {/* CITAS-MODAL: el modal se mudó a su propio componente. El estado y
          los manejadores -- GuardarCita incluido, con sus mismas cuatro
          validaciones -- siguen viviendo aquí. */}
      <ModalCita
        show={show}
        onCerrar={cerrarModalCita}
        cita={citapaciente}
        setCita={setCitaPaciente}
        pacientes={paciente}
        pacienteElegido={selectedOption}
        onElegirPaciente={handleChange}
        onCambiarPaciente={cambiarPacienteDeCita}
        onNuevoPaciente={handleShowPaciente}
        puedeCrearPaciente={hasPermission("pacientes.create")}
        procedimientosOpciones={procedimientosOpciones}
        procedimientosElegidos={procedimientosSeleccionados}
        onElegirProcedimientos={setProcedimientosSeleccionados}
        procedimientosFacturados={procedimientosFacturados}
        cargandoProcedimientos={cargandoProcedimientos}
        avisoProcedimientos={avisoProcedimientos}
        doctor={doctor}
        especialidad={especialidadSeleccionada}
        intervaloPorDefecto={intervaloEspecialidad}
        tipoCitas={tipoCitas}
        estadosCitas={estadosCitas}
        facturasPendientes={facturasPendientes}
        facturasElegidas={facturasSeleccionadas}
        onElegirFacturas={setFacturasSeleccionadas}
        guardando={guardando}
        onGuardar={GuardarCita}
        puedeGuardar={hasPermission(citapaciente.idcita ? "citas.edit" : "citas.create")}
        onCancelarCita={cancelarCita}
        puedeCancelarCita={puedeCancelarEstaCita}
      />

      {/*<Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{citapaciente.idcita === 0 ? "Crear Cita" : "Editar Cita"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 mb-3">
              <label>Paciente:</label>
              <div className="d-flex">
                <SelectSearchble listCompany={paciente} handleChange={handleChange} selectedOption={selectedOption} placeholder="Buscar Paciente" styles={{ width: '100%' }} />
                <button type="button" className="btn btn-success mx-1" onClick={handleShowPaciente}><i className="fas fa-plus"></i></button>
              </div>
            </div>
            <div className="col-6 mb-3">
              <label>Doctor:</label>
              <input type="text" className="form-control" disabled value={doctor.nombre} />
            </div>
            <div className="col-6 mb-3">
              <label>Fecha:</label>
              <input type="date" className="form-control" value={citapaciente.fecha_inicio} readOnly />
            </div>
            <div className="col-6 mb-3">
              <label>Hora Inicio:</label>
              <input type="time" className="form-control" value={citapaciente.hora_inicio} onChange={e => setCitaPaciente({ ...citapaciente, hora_inicio: e.target.value })} />
            </div>
            <div className="col-6 mb-3">
              <label>Hora Fin:</label>
              <input type="time" className="form-control" value={citapaciente.hora_fin} onChange={e => setCitaPaciente({ ...citapaciente, hora_fin: e.target.value })} />
            </div>
            <div className="col-6 mb-3">
              <label>Tipo Cita:</label>
              <select className="form-control" value={citapaciente.idtipo_cita} onChange={e => setCitaPaciente({ ...citapaciente, idtipo_cita: parseInt(e.target.value) })}>
                <option value="">-- Seleccione --</option>
                {tipoCitas.map(tipo => <option key={tipo.idtipo_cita} value={tipo.idtipo_cita}>{tipo.tipo}</option>)}
              </select>
            </div>
            <div className="col-6 mb-3">
              <label>Estado: </label>
              <select className="form-control" 
                value={citapaciente.id_estado_cita || ''} 
                onChange={e => setCitaPaciente({ ...citapaciente, id_estado_cita: parseInt(e.target.value) })}
              >
                <option value="">-- Seleccione --</option>
                {estadosCitas.map(estado => 
                  <option key={estado.idestado_cita} value={estado.idestado_cita}>{estado.estado}</option>
                )}
              </select>

            </div>
            <div className="col-12 mb-3">
              <label>Motivo:</label>
              <textarea className="form-control" value={citapaciente.motivo} onChange={e => setCitaPaciente({ ...citapaciente, motivo: e.target.value })}></textarea>
            </div>
          </div>
          <div className="text-end">
            <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>Cerrar</button>
            <button type="button" className="btn btn-success" onClick={GuardarCita}>Guardar</button>
          </div>
        </Modal.Body>
      </Modal>*/}

      <Offcanvas
        style={{ width: "50%" }}
        placement="end"
        show={showPaciente}
        onHide={handleClosePaciente}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Crear Nuevo Paciente</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <PacienteCreacion
            handleClosePaciente={handleClosePaciente}
            showPaciente={showPaciente}
            idclinica={idclinica}
            pacienteEdit={null}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
